<template>
  <div>
    <label v-if="inputLabel" :for="inputId" class="label_font">{{
      t(inputLabel, {}, { locale: $store.getters.getLang })
    }}</label>
    <input
      v-if="activeValue !== 'active'"
      :id="inputId"
      class="input_field form-control rounded py-2 px-3 w-100 mt-1"
      v-model="input"
      :type="inputType"
      autocomplete="off"
      :placeholder="inputPlaceholder"
    />
    <input
      v-else
      :id="inputId"
      class="input_field form-control rounded py-2 px-3 w-100 mt-1"
      v-model="input"
      :type="inputType"
      autocomplete="off"
      :placeholder="inputPlaceholder"
      min="0"
      oninput="this.value = Math.abs(this.value)"
    />
  </div>
</template>

<script>
import { ref, watch } from "vue";
import { useI18n } from "vue-i18n";
export default {
  name: "Input",
  props: {
    modelValue: [String, Number],
    placeholder: String,
    label: String,
    id: String,
    type: String,
    active: String,
  },
  setup(props, { emit }) {
    const inputPlaceholder = ref(props.placeholder);
    const inputLabel = ref(props.label);
    const inputId = ref(props.id);
    const inputType = ref(props.type);
    const input = ref(props.modelValue);
    const activeValue = ref(props.active);
    const { t, locale } = useI18n();
    watch(
      () => props.label,
      (value) => {
        inputLabel.value = value;
      }
    );
    watch(
      () => input.value,
      () => {
        emit("update:modelValue", input.value);
      }
    );
    watch(
      () => activeValue.value,
      (value) => {
        activeValue.value = value;
      }
    );
    watch(
      () => props.modelValue,
      (value) => {
        input.value = value;
      }
    );
    watch(
      () => props.type,
      () => {
        if (props.type === "password") {
          inputType.value = "password";
        }
        if (props.type === "email") {
          inputType.value = "email";
        }
        if (props.type === "text") {
          inputType.value = "text";
        }
      }
    );
    return {
      t,
      locale,
      inputPlaceholder,
      inputLabel,
      inputId,
      inputType,
      input,
      activeValue,
    };
  },
};
</script>

<style scoped></style>
